module.exports = __webpack_public_path__ + "static/phone.257a809f.svg";